import React from "react";
import { Link } from "react-router-dom";
const Footer = () => {
  //   const handleScroll = (sectionId) => {
  //     document.getElementById(sectionId).scrollIntoView({ behavior: 'smooth' });
  // };

  const handleScroll = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <div>
      <div className="footer ">
        <div className="container">
          <div className="row ">
            <div className="col-lg-6 mb-4 mb-lg-0">
              <img src="/images/logo.png" alt="anso" />
              <p className="mt-4">
                Pioneering a New Era of Transparent, Decentralised <br />{" "}
                Crowdfunding
              </p>
              {/* <button className="btn-green mt-3">ABOUT US</button> */}
            </div>
            <div className=" col-6 col-lg-3 mb-4 mb-lg-0">
              <label htmlFor="" className="mb-4">
                Company
              </label>
              <ul className="list-inline d-block">
                <li>
                  <Link onClick={() => handleScroll("")} to="/">
                    Home
                  </Link>
                </li>
                <li>
                  <Link to="">How it works</Link>
                </li>
                <li>
                  <Link onClick={() => handleScroll("")} to="/">
                    Feature
                  </Link>
                </li>
                <li>
                  <Link onClick={() => handleScroll("")} to="/">
                    Projects
                  </Link>
                </li>
                {/* <li>
                  <Link onClick={() => handleScroll("faq")} to="/">
                    Faq's
                  </Link>
                </li> */}
              </ul>
            </div>{" "}
            <div className=" col-6 col-lg-3 mb-4 mb-lg-0">
              <label htmlFor="" className="mb-4">
                Services
              </label>
              <ul className="list-inline d-block">
                <li>
                  <Link onClick={() => handleScroll("")} to="/">
                    Resources
                  </Link>
                </li>
                <li>
                  <Link to="">Contact</Link>
                </li>
                <li>
                  <Link onClick={() => handleScroll("")} to="/">
                    Privacy Policy
                  </Link>
                </li>
                <li>
                  <Link onClick={() => handleScroll("")} to="/">
                    Term & Conditions
                  </Link>
                </li>
                {/* <li>
                  <Link onClick={() => handleScroll("faq")} to="/">
                    Token
                  </Link>
                </li> */}
              </ul>
            </div>
            {/* <div className="col-lg-4 mb-4 mb-lg-0">
              <label htmlFor="" className="mb-4">
                WE ACCEPT CREDIT CARDS
              </label>
              <div className="d-flex align-items-center   gap-3">
                <img className="w-auto" src="/images/image 8.png" alt="" />
                <img className="w-auto" src="/images/image 9.png" alt="" />
                <img className="w-auto" src="/images/image 10.png" alt="" />
                <img className="w-auto" src="/images/image 11.png" alt="" />
              </div>
              <label htmlFor="" className="mb-3">
                Follow Us :
              </label>
              <div className="d-flex align-items-center    gap-3">
                <img className="w-auto" src="/images/instaa.png" alt="" />
                <img className="w-auto" src="/images/fbb.png" alt="" />
                <img className="w-auto" src="/images/linkdinnn.png" alt="" />
                <img className="w-auto" src="/images/twitterr.png" alt="" />
              </div>
            </div> */}
          </div>
          <div
            className="d-flex align-items-center justify-content-between w-100 pt-4 mt-5 "
            style={{ borderTop: "1px solid  rgba(46, 168, 101, 0.47)" }}
          >
            <p className="s-p">© 2025 ofnt. All rights reserved.</p>
            <div className="social-links">
              <div>
                <a href="https://github.com/OFNT" target="_blank">
                  <img src="/images/github-mark.svg" alt="facebook" />
                </a>
              </div>
              <div>
                <a href="https://x.com/openfundnet" target="_blank">
                  <img src="/images/twitter.svg" alt="twitter" />
                </a>
              </div>
              <div>
                <a href="https://t.me/+3ZjYIcshyVs5ZjUx" target="_blank">
                  <img src="/images/telegram.svg" alt="chain" />
                </a>
              </div>
              <div>
                <a href="https://discord.gg/ncvV5Yrb" target="_blank">
                  <img src="/images/discord.svg" alt="chain" />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
